import type { WebOrdersReportQuery } from "../../../api/types";

/** The report's query as URL parameters, for the person page links and back. */
export function queryParams(query: WebOrdersReportQuery): URLSearchParams {
  const params = new URLSearchParams();
  if (query.from) params.set("from", query.from);
  if (query.to) params.set("to", query.to);
  if (query.locationId) params.set("shop", query.locationId);
  return params;
}

/** The person page for the same period and shop the report is showing. */
export function personLink(userId: string, query: URLSearchParams): string {
  const qs = query.toString();
  return `/app/shopify-orders/people/${encodeURIComponent(userId)}${qs ? `?${qs}` : ""}`;
}
